// Generated by purs version 0.13.0
"use strict";
var Chip_Model_Color = require("../Chip.Model.Color/index.js");
var Chip_Model_Item = require("../Chip.Model.Item/index.js");
var withdrawKey = function (color) {
    return function (i) {
        if (color instanceof Chip_Model_Color.Red) {
            return {
                red: i.red - 1 | 0,
                cyan: i.cyan,
                yellow: i.yellow,
                green: i.green,
                skiSkates: i.skiSkates,
                suctionBoots: i.suctionBoots,
                fireBoots: i.fireBoots,
                flippers: i.flippers
            };
        };
        if (color instanceof Chip_Model_Color.Cyan) {
            return {
                red: i.red,
                cyan: i.cyan - 1 | 0,
                yellow: i.yellow,
                green: i.green,
                skiSkates: i.skiSkates,
                suctionBoots: i.suctionBoots,
                fireBoots: i.fireBoots,
                flippers: i.flippers
            };
        };
        if (color instanceof Chip_Model_Color.Yellow) {
            return {
                red: i.red,
                cyan: i.cyan,
                yellow: i.yellow - 1 | 0,
                green: i.green,
                skiSkates: i.skiSkates,
                suctionBoots: i.suctionBoots,
                fireBoots: i.fireBoots,
                flippers: i.flippers
            };
        };
        if (color instanceof Chip_Model_Color.Green) {
            return i;
        };
        throw new Error("Failed pattern match at Chip.Mutation.Inventory (line 25, column 23 - line 29, column 13): " + [ color.constructor.name ]);
    };
};
var addItem = function (item) {
    return function (inv) {
        if (item instanceof Chip_Model_Item.SkiSkates) {
            return {
                red: inv.red,
                cyan: inv.cyan,
                yellow: inv.yellow,
                green: inv.green,
                skiSkates: true,
                suctionBoots: inv.suctionBoots,
                fireBoots: inv.fireBoots,
                flippers: inv.flippers
            };
        };
        if (item instanceof Chip_Model_Item.SuctionBoots) {
            return {
                red: inv.red,
                cyan: inv.cyan,
                yellow: inv.yellow,
                green: inv.green,
                skiSkates: inv.skiSkates,
                suctionBoots: true,
                fireBoots: inv.fireBoots,
                flippers: inv.flippers
            };
        };
        if (item instanceof Chip_Model_Item.FireBoots) {
            return {
                red: inv.red,
                cyan: inv.cyan,
                yellow: inv.yellow,
                green: inv.green,
                skiSkates: inv.skiSkates,
                suctionBoots: inv.suctionBoots,
                fireBoots: true,
                flippers: inv.flippers
            };
        };
        if (item instanceof Chip_Model_Item.Flippers) {
            return {
                red: inv.red,
                cyan: inv.cyan,
                yellow: inv.yellow,
                green: inv.green,
                skiSkates: inv.skiSkates,
                suctionBoots: inv.suctionBoots,
                fireBoots: inv.fireBoots,
                flippers: true
            };
        };
        if (item instanceof Chip_Model_Item.Key) {
            if (item.value0 instanceof Chip_Model_Color.Red) {
                return {
                    red: inv.red + 1 | 0,
                    cyan: inv.cyan,
                    yellow: inv.yellow,
                    green: inv.green,
                    skiSkates: inv.skiSkates,
                    suctionBoots: inv.suctionBoots,
                    fireBoots: inv.fireBoots,
                    flippers: inv.flippers
                };
            };
            if (item.value0 instanceof Chip_Model_Color.Cyan) {
                return {
                    red: inv.red,
                    cyan: inv.cyan + 1 | 0,
                    yellow: inv.yellow,
                    green: inv.green,
                    skiSkates: inv.skiSkates,
                    suctionBoots: inv.suctionBoots,
                    fireBoots: inv.fireBoots,
                    flippers: inv.flippers
                };
            };
            if (item.value0 instanceof Chip_Model_Color.Yellow) {
                return {
                    red: inv.red,
                    cyan: inv.cyan,
                    yellow: inv.yellow + 1 | 0,
                    green: inv.green,
                    skiSkates: inv.skiSkates,
                    suctionBoots: inv.suctionBoots,
                    fireBoots: inv.fireBoots,
                    flippers: inv.flippers
                };
            };
            if (item.value0 instanceof Chip_Model_Color.Green) {
                return {
                    red: inv.red,
                    cyan: inv.cyan,
                    yellow: inv.yellow,
                    green: true,
                    skiSkates: inv.skiSkates,
                    suctionBoots: inv.suctionBoots,
                    fireBoots: inv.fireBoots,
                    flippers: inv.flippers
                };
            };
            throw new Error("Failed pattern match at Chip.Mutation.Inventory (line 17, column 16 - line 21, column 36): " + [ item.value0.constructor.name ]);
        };
        throw new Error("Failed pattern match at Chip.Mutation.Inventory (line 12, column 20 - line 21, column 36): " + [ item.constructor.name ]);
    };
};
module.exports = {
    addItem: addItem,
    withdrawKey: withdrawKey
};
